<template>
  <div>
    <ui-stage>
      <ui-admin-table
        v-if="data"
        :attributes="attributes"
        :data="data"
        :module-url="`/admi`"
        pagination-method="front-end"
        :with-create="false"
        :with-delete="false"
      >
        <template slot="toolbar">
          <div class="mb" v-if="canTriggerSync">
            <ui-button type="primary" @click="handleSync" size="small">从萤石云平台同步</ui-button>
          </div>
        </template>
        <template v-slot:column__adminActions="{ row }">
          <router-link :to="`${moduleUrl}/list/${row.id}`">
            <ui-button size="mini" type="primary" icon="el-icon-view">查看</ui-button>
          </router-link>
        </template>
        <template v-slot:column_id="{ row }">
          {{ row.id | filterId }}
        </template>
      </ui-admin-table>
    </ui-stage>
  </div>
</template>

<script>
import { adminList } from '@yishitec/web/mixins';
import permissions from '../../../mixins/permissions';

export default {
  name: 'CamsProjects',
  mixins: [adminList, permissions],
  data() {
    return {
      vvApi: '/api/cams/projects',
    };
  },
  computed: {
    canTriggerSync() {
      return this.amI(null, null, '平台管理员') || this.amI(null, '建设单位', '管理人员', true);
    },
  },
  methods: {
    async handleSync() {
      await this.withLoading(this.api('/api/cams/sync'));
      await this.fetchData();
    },
  },
  filters: {
    filterId(id) {
      return String(id)[0] === '_' ? '' : id;
    },
  },
};
</script>

<style lang="less" scoped></style>
